<template>
  <div class="app-container">
    <list ref="list" >
        <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        </template>
        <template slot="column">
            <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
            <el-table-column label="状态" align="center" width="80">
              <template slot-scope="{row}">
                  <span type="text" style="font-size: 14px;">{{row.Disabled == false ? '启用' : '停用'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" align="center" width="160" v-if="$permission.canWrite()">
                <template slot-scope="{row}">
                    <el-button type="text" @click.stop="edit(row)">编辑</el-button>
                    <el-button type="text" @click.stop="del(row)">{{row.Disabled == true ? '启用' : '停用'}}</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from '@/components/production/craftsmanship/assemblingbom/list'

export default {
  name: "bom",
  mixins: [curdMixins],
  components: {
    list,
  },
 data(){
    return {
      api: require("@/api/production/teProduct").default,
    }
  },
  methods: {
    del({TeProductId}){
      let id = TeProductId;
      this.api.change({id}).then(res => {
        if(res.Code === 0){
          this.$message({type: 'success', message: res.Msg})
          this.$refs.list.getData();
        }else{
          this.$message({type: 'warning', message: res.Msg})
        }
      })
    },
    create(){
      this.toURL({
        name: 'editassemblingbom',
        params: {
          type: 'create'
        }
      })
    },
    edit(row){
      this.toURL({
        name: 'editassemblingbom',
        params: {
          type: 'edit',
          data: row
        }
      })
    },
    toURL(o){
      this.$router.push(o)
    }
      
  }
  
};
</script>